<template>
  <div class="layout-box" :class="{ layout2: property_data.type === 2 }">
    <!-- 不加key， 没有唯一值， 用index有可能更新不渲染 -->
    <div class="card-box" v-for="(item, index) in showData" @click="jump(item.id)">
      <el-image class="card-image" fit="contain" :src="item.img_url"></el-image>
      <div class="right">
        <div class="card-item-title ellipsis2">
          {{ item.title }}
        </div>

        <div class="price-btn">
          <div class="price-box" v-if="property_data.type === 1">
            <div class="price-item">
              活动价：<span :style="`color: ${property_data.price_color};`">{{
                item.price
              }}</span>
            </div>
            <div class="price-item">
              佣金率：<span :style="`color: ${property_data.price_color};`"
                >{{ item.commission }}%</span
              >
            </div>
          </div>

          <div
            class="btn-box ellipsis"
            :style="`background-color: ${property_data.btn_bg_color};`"
            v-if="property_data.type === 2"
          >
            <div class="btn-sal img-flex">
              活动价:{{ item.price }}&nbsp;佣金率:{{ item.commission }}%
            </div>
          </div>
          <div
            v-if="property_data.type === 1"
          >
            <div class="btn-box img-flex" :style="`background-color: ${property_data.btn_bg_color};`">立即开卖<el-image style="height: 1.1rem; margin-left:0.4rem" src="https://mktv-in-cdn.mockuai.com/16401543454974860.png"></el-image></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { redirectURL } from "@/js/jump";
export default {
  name: "tms-active-day3",
  props: ["config", "isEditorStatus", "pageData"],
  data() {
    return {};
  },
  computed: {
    app_type() {
      return this.pageData.app_type || "seller";
    },
    showData() {
      if (this.listData.length) {
        return this.listData;
      }
      return this.notData;
    },
    notData() {
      const obj = {
        img_url: "https://mktv-in-cdn.mockuai.com/16397202064747389.png",
        title:
          "蔬小简综合7+谷物优D型片蔬小简综合7+谷物优D型片优D型片蔬小简综合7+谷物优D型片",
        price: 782.33,
        commission: "43.44"
      };
      if (this.property_data.type === 2) {
        return [obj, obj];
      } else {
        return [obj];
      }
    },
    listData() {
      if (this.property_data.list && this.property_data.list.length) {
        return this.property_data.list;
      }
      return [];
    },
    property_data() {
      return this.config.property_data;
    }
  },
  methods: {
    jump(id) {
      if (this.isEditorStatus) {
        return;
      }
      redirectURL(String(id), this.app_type);
    }
  }
};
</script>

<style scoped>
.layout2 {
  display: grid;
  grid-column-gap: 2.81%;
  grid-template-columns: 48.595% 48.595%;
  margin: 0 10px;
  /* 不用1fr是因为内容撑开会把容器撑开， 用了overflow， 会把title的效果在容器外面部分截取了 */
}

.layout2 .card-box {
  display: flex;
  flex-direction: column;
  border-radius: 5px;
}

.card-box {
  display: flex;
  background: #fff;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 10px;
  overflow: hidden;
}

.layout2 .card-image {
  width: 17.3rem;
  height: 17.3rem;
  box-shadow: none;
}
.card-image{
  box-shadow: 3px 3px 10px rgba(125, 125, 125, 0.2);
  margin: 10px;
  margin-right: 0;
  border-radius: 5px;
}

.layout2 .right {
  padding: 7px 5px;
  background: #f4f4f4;
  margin: 0;
}
.right {
  flex: 1;
  margin: 0 12px 0.6rem 22px;
}

.price-btn {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.layout2 .card-item-title {
  margin-bottom: 8px;
  margin-top: 0;
  font-weight: 300;
}

.card-item-title {
  font-size: 1.3rem;
  line-height: 1.5;
  color: #000;
  text-align: left;
  font-weight: 500;
  margin-top: 0.6rem;
  margin-bottom: 1.2rem;
  min-height: 39px;
}

.card-image {
  width: 9.4rem;
  height: 9.4rem;
  background-color: #fff;
}


.layout2 .btn-box {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 2.8rem;
  line-height: 2.8rem;
}
.layout2 .btn-sal {
  transform: scale(0.5);
  font-size: 2.2rem;
}

.price-item span{
  font-family: mockuai;
}

.btn-box {
  width: 9rem;
  height: 2.4rem;
  line-height: 2.4rem;
  text-align: center;
  border-radius: 1.4rem;
  font-size: 1.4rem;
  color: #fff;
  font-weight: 500;
}

.ellipsis {
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
}
.ellipsis2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
}
.price-box {
  font-size: 1.4rem;
  color: #000;
}
.price-item + .price-item {
  margin-top: 4px;
}

.img-flex{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
